import invariant from 'tiny-invariant';

import type { SubmitInvoicePayload, UpdateDraftInvoicePayload } from '~/api/invoices';

import { flattenFormSectionsToLines } from '~/features/documents';

import type { CreateEditInvoiceFormType } from './CreateEditInvoice/types';

export const mapInvoiceFormDataToDraftPayload = (data: CreateEditInvoiceFormType) =>
  ({
    brandId: data.brandId,
    clientContactId: data.contactId,
    clientId: data.clientId,
    clientReference: data.clientReference,
    conditionId: data.condition?.type === 'condition' ? data.condition.id : null,
    customAgreementId: data.condition?.type === 'customAgreement' ? data.condition.id : null,
    customConditionId: data.condition?.type === 'customCondition' ? data.condition.id : null,
    description: data.description,
    invoiceLines: data.sections ? flattenFormSectionsToLines(data.sections) : [],
    numberingSeriesId: data.numberingSeriesId,
    paymentTerm: data.paymentTerm,
    paymentTermEndOfMonth: data.paymentTermEndOfMonth,
    specialConditions: data.specialConditions,
    title: data.title,
    userComments: data.userComments,
  }) satisfies UpdateDraftInvoicePayload;

export const mapInvoiceFormDataToPayload = (data: CreateEditInvoiceFormType) => {
  // Narrow types of required fields
  invariant(data.brandId !== null, 'Expected brandId to be defined.');
  invariant(data.clientId !== null, 'Expected clientId to be defined.');
  invariant(data.contactId !== null, 'Expected contactId to be defined.');
  invariant(data.condition !== null, 'Expected condition to be defined.');
  invariant(data.numberingSeriesId !== null, 'Expected numberingSeriesId to be defined.');

  return {
    brandId: data.brandId,
    clientContactId: data.contactId,
    clientId: data.clientId,
    clientReference: data.clientReference,
    conditionId: data.condition?.type === 'condition' ? data.condition.id : null,
    customAgreementId: data.condition?.type === 'customAgreement' ? data.condition.id : null,
    customConditionId: data.condition?.type === 'customCondition' ? data.condition.id : null,
    description: data.description,
    invoiceLines: data.sections ? flattenFormSectionsToLines(data.sections) : [],
    numberingSeriesId: data.numberingSeriesId,
    paymentTerm: data.paymentTerm,
    paymentTermEndOfMonth: data.paymentTermEndOfMonth,
    specialConditions: data.specialConditions,
    title: data.title,
    userComments: data.userComments,
  } satisfies Omit<SubmitInvoicePayload, 'approvalType' | 'fcEntryNumber' | 'nextNumber'>;
};
